'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedSize extends Component {
  render() {
    const _this$props = this.props,
      {
        value
      } = _this$props,
      options = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("span", {
      children: I18n.formatSize(value, options)
    });
  }
}
FormattedSize.displayName = 'FormattedSize';
FormattedSize.propTypes = {
  value: PropTypes.number.isRequired
};